window.PandectesRulesSettings = {
  store: {
    id: 32716095533,
    adminMode: false,
    headless: false,
    storefrontRootDomain: "",
    checkoutRootDomain: "",
    storefrontAccessToken: "",
  },
  banner: {
    revokableTrigger: true,
    cookiesBlockedByDefault: "7",
    hybridStrict: false,
    isActive: true,
  },
  geolocation: {
    auOnly: false,
    brOnly: false,
    caOnly: false,
    chOnly: false,
    euOnly: false,
    jpOnly: false,
    nzOnly: false,
    thOnly: false,
    zaOnly: false,
    canadaOnly: false,
    canadaLaw25: false,
    canadaPipeda: false,
    globalVisibility: true,
  },
  blocker: {
    isActive: true,
    googleConsentMode: {
      isActive: false,
      id: "",
      analyticsId: "",
      onlyGtm: false,
      adwordsId: "",
      adStorageCategory: 4,
      analyticsStorageCategory: 2,
      functionalityStorageCategory: 1,
      personalizationStorageCategory: 1,
      securityStorageCategory: 0,
      customEvent: true,
      redactData: false,
      urlPassthrough: false,
      dataLayerProperty: "dataLayer",
      waitForUpdate: 500,
      useNativeChannel: false,
      debugMode: false,
    },
    facebookPixel: { isActive: false, id: "", ldu: false },
    microsoft: { isActive: true, uetTags: "" },
    clarity: { isActive: true, id: "" },
    rakuten: { isActive: false, cmp: false, ccpa: false },
    gpcIsActive: true,
    klaviyoIsActive: false,
    defaultBlocked: 7,
    patterns: {
      whiteList: [],
      blackList: {
        1: [],
        2: ["n.clarity.ms"],
        4: [
          "bat.bing.com",
          "s.pinimg.com/ct/core.js|s.pinimg.com/ct/lib",
          "linksynergy.com",
        ],
        8: [],
      },
      iframesWhiteList: [],
      iframesBlackList: { 1: [], 2: [], 4: [], 8: [] },
      beaconsWhiteList: [],
      beaconsBlackList: { 1: [], 2: [], 4: [], 8: [] },
    },
  },
};
!(function () {
  "use strict";
  (window.PandectesRules = window.PandectesRules || {}),
    (window.PandectesRules.manualBlacklist = { 1: [], 2: [], 4: [] }),
    (window.PandectesRules.blacklistedIFrames = { 1: [], 2: [], 4: [] }),
    (window.PandectesRules.blacklistedCss = { 1: [], 2: [], 4: [] }),
    (window.PandectesRules.blacklistedBeacons = { 1: [], 2: [], 4: [] });
  const e = "javascript/blocked",
    t = [
      "US-CA",
      "US-VA",
      "US-CT",
      "US-UT",
      "US-CO",
      "US-MT",
      "US-TX",
      "US-OR",
      "US-IA",
      "US-NE",
      "US-NH",
      "US-DE",
      "US-NJ",
      "US-TN",
      "US-MN",
    ],
    n = [
      "AT",
      "BE",
      "BG",
      "HR",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "SE",
      "GB",
      "LI",
      "NO",
      "IS",
    ];
  function a(e) {
    return new RegExp(e.replace(/[/\\.+?$()]/g, "\\$&").replace("*", "(.*)"));
  }
  const o = (e, t = "log") => {
    new URLSearchParams(window.location.search).get("log") &&
      console[t](`PandectesRules: ${e}`);
  };
  function s(e) {
    const t = document.createElement("script");
    (t.async = !0), (t.src = e), document.head.appendChild(t);
  }
  const r = window.PandectesRulesSettings || window.PandectesSettings,
    i = (function () {
      if (void 0 !== window.dataLayer && Array.isArray(window.dataLayer)) {
        if (window.dataLayer.some((e) => "pandectes_full_scan" === e.event))
          return !0;
      }
      return !1;
    })(),
    c = ((e = "_pandectes_gdpr") => {
      const t = ("; " + document.cookie).split("; " + e + "=");
      let n;
      if (t.length < 2) n = {};
      else {
        const e = t.pop().split(";");
        n = window.atob(e.shift());
      }
      const a = ((e) => {
        try {
          return JSON.parse(e);
        } catch (e) {
          return !1;
        }
      })(n);
      return !1 !== a ? a : n;
    })(),
    {
      banner: { isActive: l },
      blocker: { defaultBlocked: d, patterns: u },
    } = r,
    g =
      c && null !== c.preferences && void 0 !== c.preferences
        ? c.preferences
        : null,
    p = i ? 0 : l ? (null === g ? d : g) : 0,
    f = { 1: !(1 & p), 2: !(2 & p), 4: !(4 & p) },
    {
      blackList: h,
      whiteList: y,
      iframesBlackList: w,
      iframesWhiteList: m,
      beaconsBlackList: b,
      beaconsWhiteList: k,
    } = u,
    _ = {
      blackList: [],
      whiteList: [],
      iframesBlackList: { 1: [], 2: [], 4: [], 8: [] },
      iframesWhiteList: [],
      beaconsBlackList: { 1: [], 2: [], 4: [], 8: [] },
      beaconsWhiteList: [],
    };
  [1, 2, 4].map((e) => {
    f[e] ||
      (_.blackList.push(...(h[e].length ? h[e].map(a) : [])),
      (_.iframesBlackList[e] = w[e].length ? w[e].map(a) : []),
      (_.beaconsBlackList[e] = b[e].length ? b[e].map(a) : []));
  }),
    (_.whiteList = y.length ? y.map(a) : []),
    (_.iframesWhiteList = m.length ? m.map(a) : []),
    (_.beaconsWhiteList = k.length ? k.map(a) : []);
  const v = {
      scripts: [],
      iframes: { 1: [], 2: [], 4: [] },
      beacons: { 1: [], 2: [], 4: [] },
      css: { 1: [], 2: [], 4: [] },
    },
    L = (t, n) =>
      t &&
      (!n || n !== e) &&
      (!_.blackList || _.blackList.some((e) => e.test(t))) &&
      (!_.whiteList || _.whiteList.every((e) => !e.test(t))),
    S = (e, t) => {
      const n = _.iframesBlackList[t],
        a = _.iframesWhiteList;
      return (
        e &&
        (!n || n.some((t) => t.test(e))) &&
        (!a || a.every((t) => !t.test(e)))
      );
    },
    C = (e, t) => {
      const n = _.beaconsBlackList[t],
        a = _.beaconsWhiteList;
      return (
        e &&
        (!n || n.some((t) => t.test(e))) &&
        (!a || a.every((t) => !t.test(e)))
      );
    },
    A = new MutationObserver((e) => {
      for (let t = 0; t < e.length; t++) {
        const { addedNodes: n } = e[t];
        for (let e = 0; e < n.length; e++) {
          const t = n[e],
            a = t.dataset && t.dataset.cookiecategory;
          if (1 === t.nodeType && "LINK" === t.tagName) {
            const e = t.dataset && t.dataset.href;
            if (e && a)
              switch (a) {
                case "functionality":
                case "C0001":
                  v.css[1].push(e);
                  break;
                case "performance":
                case "C0002":
                  v.css[2].push(e);
                  break;
                case "targeting":
                case "C0003":
                  v.css[4].push(e);
              }
          }
        }
      }
    });
  var $ = new MutationObserver((t) => {
    for (let n = 0; n < t.length; n++) {
      const { addedNodes: a } = t[n];
      for (let t = 0; t < a.length; t++) {
        const n = a[t],
          s = n.src || (n.dataset && n.dataset.src),
          r = n.dataset && n.dataset.cookiecategory;
        if (1 === n.nodeType && "IFRAME" === n.tagName) {
          if (s) {
            let e = !1;
            S(s, 1) || "functionality" === r || "C0001" === r
              ? ((e = !0), v.iframes[1].push(s))
              : S(s, 2) || "performance" === r || "C0002" === r
                ? ((e = !0), v.iframes[2].push(s))
                : (S(s, 4) || "targeting" === r || "C0003" === r) &&
                  ((e = !0), v.iframes[4].push(s)),
              e && (n.removeAttribute("src"), n.setAttribute("data-src", s));
          }
        } else if (1 === n.nodeType && "IMG" === n.tagName) {
          if (s) {
            let e = !1;
            C(s, 1)
              ? ((e = !0), v.beacons[1].push(s))
              : C(s, 2)
                ? ((e = !0), v.beacons[2].push(s))
                : C(s, 4) && ((e = !0), v.beacons[4].push(s)),
              e && (n.removeAttribute("src"), n.setAttribute("data-src", s));
          }
        } else if (1 === n.nodeType && "SCRIPT" === n.tagName) {
          const t = n.type;
          let a = !1;
          if (
            (L(s, t)
              ? (o(`rule blocked: ${s}`), (a = !0))
              : s && r
                ? o(`manually blocked @ ${r}: ${s}`)
                : r && o(`manually blocked @ ${r}: inline code`),
            a)
          ) {
            v.scripts.push([n, t]), (n.type = e);
            const a = function (t) {
              n.getAttribute("type") === e && t.preventDefault(),
                n.removeEventListener("beforescriptexecute", a);
            };
            n.addEventListener("beforescriptexecute", a),
              n.parentElement && n.parentElement.removeChild(n);
          }
        }
      }
    }
  });
  const P = document.createElement,
    E = {
      src: Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, "src"),
      type: Object.getOwnPropertyDescriptor(
        HTMLScriptElement.prototype,
        "type",
      ),
    };
  (window.PandectesRules.unblockCss = (e) => {
    const t = v.css[e] || [];
    t.length && o(`Unblocking CSS for ${e}`),
      t.forEach((e) => {
        const t = document.querySelector(`link[data-href^="${e}"]`);
        t.removeAttribute("data-href"), (t.href = e);
      }),
      (v.css[e] = []);
  }),
    (window.PandectesRules.unblockIFrames = (e) => {
      const t = v.iframes[e] || [];
      t.length && o(`Unblocking IFrames for ${e}`),
        (_.iframesBlackList[e] = []),
        t.forEach((e) => {
          const t = document.querySelector(`iframe[data-src^="${e}"]`);
          t.removeAttribute("data-src"), (t.src = e);
        }),
        (v.iframes[e] = []);
    }),
    (window.PandectesRules.unblockBeacons = (e) => {
      const t = v.beacons[e] || [];
      t.length && o(`Unblocking Beacons for ${e}`),
        (_.beaconsBlackList[e] = []),
        t.forEach((e) => {
          const t = document.querySelector(`img[data-src^="${e}"]`);
          t.removeAttribute("data-src"), (t.src = e);
        }),
        (v.beacons[e] = []);
    }),
    (window.PandectesRules.unblockInlineScripts = function (e) {
      const t =
          1 === e ? "functionality" : 2 === e ? "performance" : "targeting",
        n = document.querySelectorAll(
          `script[type="javascript/blocked"][data-cookiecategory="${t}"]`,
        );
      o(`unblockInlineScripts: ${n.length} in ${t}`),
        n.forEach(function (e) {
          const t = document.createElement("script");
          (t.type = "text/javascript"),
            e.hasAttribute("src")
              ? (t.src = e.getAttribute("src"))
              : (t.textContent = e.textContent),
            document.head.appendChild(t),
            e.parentNode.removeChild(e);
        });
    }),
    (window.PandectesRules.unblockInlineCss = function (e) {
      const t =
          1 === e ? "functionality" : 2 === e ? "performance" : "targeting",
        n = document.querySelectorAll(`link[data-cookiecategory="${t}"]`);
      o(`unblockInlineCss: ${n.length} in ${t}`),
        n.forEach(function (e) {
          e.href = e.getAttribute("data-href");
        });
    }),
    (window.PandectesRules.unblock = function (e) {
      e.length < 1
        ? ((_.blackList = []),
          (_.whiteList = []),
          (_.iframesBlackList = []),
          (_.iframesWhiteList = []))
        : (_.blackList &&
            (_.blackList = _.blackList.filter((t) =>
              e.every((e) =>
                "string" == typeof e
                  ? !t.test(e)
                  : e instanceof RegExp
                    ? t.toString() !== e.toString()
                    : void 0,
              ),
            )),
          _.whiteList &&
            (_.whiteList = [
              ..._.whiteList,
              ...e
                .map((e) => {
                  if ("string" == typeof e) {
                    const t = ".*" + a(e) + ".*";
                    if (_.whiteList.every((e) => e.toString() !== t.toString()))
                      return new RegExp(t);
                  } else if (
                    e instanceof RegExp &&
                    _.whiteList.every((t) => t.toString() !== e.toString())
                  )
                    return e;
                  return null;
                })
                .filter(Boolean),
            ]));
      let t = 0;
      [...v.scripts].forEach(([e, n], a) => {
        if (
          (function (e) {
            const t = e.getAttribute("src");
            return (
              (_.blackList && _.blackList.every((e) => !e.test(t))) ||
              (_.whiteList && _.whiteList.some((e) => e.test(t)))
            );
          })(e)
        ) {
          const o = document.createElement("script");
          for (let t = 0; t < e.attributes.length; t++) {
            let n = e.attributes[t];
            "src" !== n.name &&
              "type" !== n.name &&
              o.setAttribute(n.name, e.attributes[t].value);
          }
          o.setAttribute("src", e.src),
            o.setAttribute("type", n || "application/javascript"),
            document.head.appendChild(o),
            v.scripts.splice(a - t, 1),
            t++;
        }
      }),
        0 == _.blackList.length &&
          0 === _.iframesBlackList[1].length &&
          0 === _.iframesBlackList[2].length &&
          0 === _.iframesBlackList[4].length &&
          0 === _.beaconsBlackList[1].length &&
          0 === _.beaconsBlackList[2].length &&
          0 === _.beaconsBlackList[4].length &&
          (o("Disconnecting observers"), $.disconnect(), A.disconnect());
    });
  const {
      store: {
        adminMode: B,
        headless: T,
        storefrontRootDomain: R,
        checkoutRootDomain: I,
        storefrontAccessToken: O,
      },
      banner: { isActive: N },
      blocker: U,
    } = r,
    { defaultBlocked: D } = U;
  N &&
    (function (e) {
      if (window.Shopify && window.Shopify.customerPrivacy) return void e();
      let t = null;
      window.Shopify &&
      window.Shopify.loadFeatures &&
      window.Shopify.trackingConsent
        ? e()
        : (t = setInterval(() => {
            window.Shopify &&
              window.Shopify.loadFeatures &&
              (clearInterval(t),
              window.Shopify.loadFeatures(
                [{ name: "consent-tracking-api", version: "0.1" }],
                (t) => {
                  t
                    ? o("Shopify.customerPrivacy API - failed to load")
                    : (o(
                        `shouldShowBanner() -> ${window.Shopify.trackingConsent.shouldShowBanner()} | saleOfDataRegion() -> ${window.Shopify.trackingConsent.saleOfDataRegion()}`,
                      ),
                      e());
                },
              ));
          }, 10));
    })(() => {
      !(function () {
        const e = window.Shopify.trackingConsent;
        if (!1 !== e.shouldShowBanner() || null !== g || 7 !== D)
          try {
            const t = B && !(window.Shopify && window.Shopify.AdminBarInjector);
            let n = {
              preferences: !(1 & p) || i || t,
              analytics: !(2 & p) || i || t,
              marketing: !(4 & p) || i || t,
            };
            T &&
              ((n.headlessStorefront = !0),
              (n.storefrontRootDomain = R?.length
                ? R
                : window.location.hostname),
              (n.checkoutRootDomain = I?.length
                ? I
                : `checkout.${window.location.hostname}`),
              (n.storefrontAccessToken = O?.length ? O : "")),
              (e.firstPartyMarketingAllowed() === n.marketing &&
                e.analyticsProcessingAllowed() === n.analytics &&
                e.preferencesProcessingAllowed() === n.preferences) ||
                e.setTrackingConsent(n, function (e) {
                  e && e.error
                    ? o(
                        "Shopify.customerPrivacy API - failed to setTrackingConsent",
                      )
                    : o(`setTrackingConsent(${JSON.stringify(n)})`);
                });
          } catch (e) {
            o("Shopify.customerPrivacy API - exception");
          }
      })(),
        (function () {
          if (T) {
            const e = window.Shopify.trackingConsent,
              t = e.currentVisitorConsent();
            if (navigator.globalPrivacyControl && "" === t.sale_of_data) {
              const t = { sale_of_data: !1, headlessStorefront: !0 };
              (t.storefrontRootDomain = R?.length
                ? R
                : window.location.hostname),
                (t.checkoutRootDomain = I?.length
                  ? I
                  : `checkout.${window.location.hostname}`),
                (t.storefrontAccessToken = O?.length ? O : ""),
                e.setTrackingConsent(t, function (e) {
                  e && e.error
                    ? o(
                        `Shopify.customerPrivacy API - failed to setTrackingConsent({${JSON.stringify(t)})`,
                      )
                    : o(`setTrackingConsent(${JSON.stringify(t)})`);
                });
            }
          }
        })();
    });
  const M = "[Pandectes :: Google Consent Mode debug]:";
  function z(...e) {
    const t = e[0],
      n = e[1],
      a = e[2];
    if ("consent" !== t) return "config" === t ? "config" : void 0;
    const {
        ad_storage: o,
        ad_user_data: s,
        ad_personalization: r,
        functionality_storage: i,
        analytics_storage: c,
        personalization_storage: l,
        security_storage: d,
      } = a,
      u = {
        Command: t,
        Mode: n,
        ad_storage: o,
        ad_user_data: s,
        ad_personalization: r,
        functionality_storage: i,
        analytics_storage: c,
        personalization_storage: l,
        security_storage: d,
      };
    return (
      console.table(u),
      "default" === n &&
        (("denied" === o &&
          "denied" === s &&
          "denied" === r &&
          "denied" === i &&
          "denied" === c &&
          "denied" === l) ||
          console.warn(
            `${M} all types in a "default" command should be set to "denied" except for security_storage that should be set to "granted"`,
          )),
      n
    );
  }
  let j = !1,
    x = !1;
  function q(e) {
    e &&
      ("default" === e
        ? ((j = !0),
          x &&
            console.warn(
              `${M} "default" command was sent but there was already an "update" command before it.`,
            ))
        : "update" === e
          ? ((x = !0),
            j ||
              console.warn(
                `${M} "update" command was sent but there was no "default" command before it.`,
              ))
          : "config" === e &&
            (j ||
              console.warn(
                `${M} a tag read consent state before a "default" command was sent.`,
              )));
  }
  const {
    banner: { isActive: F, hybridStrict: W },
    geolocation: {
      caOnly: H = !1,
      euOnly: G = !1,
      brOnly: J = !1,
      jpOnly: V = !1,
      thOnly: K = !1,
      chOnly: Z = !1,
      zaOnly: Y = !1,
      canadaOnly: X = !1,
      globalVisibility: Q = !0,
    },
    blocker: {
      defaultBlocked: ee = 7,
      googleConsentMode: {
        isActive: te,
        onlyGtm: ne = !1,
        customEvent: ae,
        id: oe = "",
        analyticsId: se = "",
        adwordsId: re = "",
        redactData: ie,
        urlPassthrough: ce,
        adStorageCategory: le,
        analyticsStorageCategory: de,
        functionalityStorageCategory: ue,
        personalizationStorageCategory: ge,
        securityStorageCategory: pe,
        dataLayerProperty: fe = "dataLayer",
        waitForUpdate: he = 0,
        useNativeChannel: ye = !1,
        debugMode: we = !1,
      },
    },
  } = r;
  function me() {
    window[fe].push(arguments);
  }
  window[fe] = window[fe] || [];
  const be = {
    hasInitialized: !1,
    useNativeChannel: !1,
    ads_data_redaction: !1,
    url_passthrough: !1,
    data_layer_property: "dataLayer",
    storage: {
      ad_storage: "granted",
      ad_user_data: "granted",
      ad_personalization: "granted",
      analytics_storage: "granted",
      functionality_storage: "granted",
      personalization_storage: "granted",
      security_storage: "granted",
    },
  };
  if (F && te) {
    we &&
      ((ke = fe || "dataLayer"),
      window[ke].forEach((e) => {
        q(z(...e));
      }),
      (window[ke].push = function (...e) {
        return q(z(...e[0])), Array.prototype.push.apply(this, e);
      }));
    const e = 0 === (ee & le) ? "granted" : "denied",
      a = 0 === (ee & de) ? "granted" : "denied",
      o = 0 === (ee & ue) ? "granted" : "denied",
      r = 0 === (ee & ge) ? "granted" : "denied",
      i = 0 === (ee & pe) ? "granted" : "denied";
    (be.hasInitialized = !0),
      (be.useNativeChannel = ye),
      (be.url_passthrough = ce),
      (be.ads_data_redaction = "denied" === e && ie),
      (be.storage.ad_storage = e),
      (be.storage.ad_user_data = e),
      (be.storage.ad_personalization = e),
      (be.storage.analytics_storage = a),
      (be.storage.functionality_storage = o),
      (be.storage.personalization_storage = r),
      (be.storage.security_storage = i),
      (be.data_layer_property = fe || "dataLayer"),
      me("set", "developer_id.dMTZkMj", !0),
      be.ads_data_redaction &&
        me("set", "ads_data_redaction", be.ads_data_redaction),
      be.url_passthrough && me("set", "url_passthrough", be.url_passthrough),
      (function () {
        const e =
          p !== ee
            ? { wait_for_update: he || 500 }
            : he
              ? { wait_for_update: he }
              : {};
        Q && !W
          ? me("consent", "default", { ...be.storage, ...e })
          : (me("consent", "default", {
              ...be.storage,
              ...e,
              region: [
                ...(G || W ? n : []),
                ...(H && !W ? t : []),
                ...(J && !W ? ["BR"] : []),
                ...(V && !W ? ["JP"] : []),
                ...(!1 === X || W ? [] : ["CA"]),
                ...(K && !W ? ["TH"] : []),
                ...(Z && !W ? ["CH"] : []),
                ...(Y && !W ? ["ZA"] : []),
              ],
            }),
            me("consent", "default", {
              ad_storage: "granted",
              ad_user_data: "granted",
              ad_personalization: "granted",
              analytics_storage: "granted",
              functionality_storage: "granted",
              personalization_storage: "granted",
              security_storage: "granted",
              ...e,
            }));
        if (null !== g) {
          const e = 0 === (p & le) ? "granted" : "denied",
            t = 0 === (p & de) ? "granted" : "denied",
            n = 0 === (p & ue) ? "granted" : "denied",
            a = 0 === (p & ge) ? "granted" : "denied",
            o = 0 === (p & pe) ? "granted" : "denied";
          (be.storage.ad_storage = e),
            (be.storage.ad_user_data = e),
            (be.storage.ad_personalization = e),
            (be.storage.analytics_storage = t),
            (be.storage.functionality_storage = n),
            (be.storage.personalization_storage = a),
            (be.storage.security_storage = o),
            me("consent", "update", be.storage);
        }
        me("js", new Date());
        const a = "https://www.googletagmanager.com";
        if (oe.length) {
          const e = oe.split(",");
          window[be.data_layer_property].push({
            "gtm.start": new Date().getTime(),
            event: "gtm.js",
          });
          for (let t = 0; t < e.length; t++) {
            const n =
              "dataLayer" !== be.data_layer_property
                ? `&l=${be.data_layer_property}`
                : "";
            s(`${a}/gtm.js?id=${e[t].trim()}${n}`);
          }
        }
        if (se.length) {
          const e = se.split(",");
          for (let t = 0; t < e.length; t++) {
            const n = e[t].trim();
            n.length &&
              (s(`${a}/gtag/js?id=${n}`),
              me("config", n, { send_page_view: !1 }));
          }
        }
        if (re.length) {
          const e = re.split(",");
          for (let t = 0; t < e.length; t++) {
            const n = e[t].trim();
            n.length &&
              (s(`${a}/gtag/js?id=${n}`),
              me("config", n, { allow_enhanced_conversions: !0 }));
          }
        }
      })();
  } else if (ne) {
    const e = "https://www.googletagmanager.com";
    if (oe.length) {
      const t = oe.split(",");
      for (let n = 0; n < t.length; n++) {
        const a =
          "dataLayer" !== be.data_layer_property
            ? `&l=${be.data_layer_property}`
            : "";
        s(`${e}/gtm.js?id=${t[n].trim()}${a}`);
      }
    }
  }
  var ke;
  const {
    blocker: {
      klaviyoIsActive: _e,
      googleConsentMode: { adStorageCategory: ve },
    },
  } = r;
  _e &&
    window.addEventListener("PandectesEvent_OnConsent", function (e) {
      const { preferences: t } = e.detail;
      if (null != t) {
        const e = 0 === (t & ve) ? "granted" : "denied";
        void 0 !== window.klaviyo &&
          window.klaviyo.isIdentified() &&
          window.klaviyo.push([
            "identify",
            { ad_personalization: e, ad_user_data: e },
          ]);
      }
    });
  const {
    banner: { revokableTrigger: Le },
  } = r;
  Le &&
    (window.onload = async () => {
      for await (let e of ((e, t = 1e3, n = 1e4) => {
        const a = new WeakMap();
        return {
          async *[Symbol.asyncIterator]() {
            const o = Date.now();
            for (; Date.now() - o < n; ) {
              const n = document.querySelectorAll(e);
              for (const e of n) a.has(e) || (a.set(e, !0), yield e);
              await new Promise((e) => setTimeout(e, t));
            }
          },
        };
      })('a[href*="#reopenBanner"]'))
        e.onclick = (e) => {
          e.preventDefault(), window.Pandectes.fn.revokeConsent();
        };
    });
  const {
      banner: { isActive: Se },
      blocker: {
        defaultBlocked: Ce = 7,
        microsoft: {
          isActive: Ae,
          uetTags: $e,
          dataLayerProperty: Pe = "uetq",
        } = { isActive: !1, uetTags: "", dataLayerProperty: "uetq" },
        clarity: { isActive: Ee, id: Be } = { isActive: !1, id: "" },
      },
    } = r,
    Te = {
      hasInitialized: !1,
      data_layer_property: "uetq",
      storage: { ad_storage: "granted" },
    };
  if (Se && Ae) {
    if (
      ((function (e, t, n) {
        const a = new Date();
        a.setTime(a.getTime() + 24 * n * 60 * 60 * 1e3);
        const o = "expires=" + a.toUTCString();
        document.cookie = `${e}=${t}; ${o}; path=/; secure; samesite=strict`;
      })("_uetmsdns", "0", 365),
      $e.length)
    ) {
      const e = $e.split(",");
      for (let t = 0; t < e.length; t++) e[t].trim().length && ze(e[t]);
    }
    const e = 4 & Ce ? "denied" : "granted";
    if (
      ((Te.hasInitialized = !0),
      (Te.storage.ad_storage = e),
      (window[Pe] = window[Pe] || []),
      window[Pe].push("consent", "default", Te.storage),
      null !== g)
    ) {
      const e = 4 & p ? "denied" : "granted";
      (Te.storage.ad_storage = e),
        window[Pe].push("consent", "update", Te.storage);
    }
  }
  var Re, Ie, Oe, Ne, Ue, De, Me;
  function ze(e) {
    const t = document.createElement("script");
    (t.type = "text/javascript"),
      (t.async = !0),
      (t.src = "//bat.bing.com/bat.js"),
      (t.onload = function () {
        const t = { ti: e, cookieFlags: "SameSite=None;Secure" };
        (t.q = window[Pe]),
          (window[Pe] = new UET(t)),
          window[Pe].push("pageLoad");
      }),
      document.head.appendChild(t);
  }
  Ee &&
    Se &&
    (Be.length &&
      ((Re = window),
      (Ie = document),
      (Ne = "script"),
      (Ue = Be),
      (Re[(Oe = "clarity")] =
        Re[Oe] ||
        function () {
          (Re[Oe].q = Re[Oe].q || []).push(arguments);
        }),
      ((De = Ie.createElement(Ne)).async = 1),
      (De.src = "https://www.clarity.ms/tag/" + Ue),
      (Me = Ie.getElementsByTagName(Ne)[0]).parentNode.insertBefore(De, Me)),
    window.addEventListener("PandectesEvent_OnConsent", (e) => {
      ["new", "revoke"].includes(e.detail?.consentType) &&
        "function" == typeof window.clarity &&
        (2 & e.detail?.preferences
          ? window.clarity("consent", !1)
          : window.clarity("consent"));
    })),
    (window.PandectesRules.gcm = be);
  const {
    banner: { isActive: je },
    blocker: { isActive: xe },
  } = r;
  o(
    `Prefs: ${p} | Banner: ${je ? "on" : "off"} | Blocker: ${xe ? "on" : "off"}`,
  );
  const qe = null === g && /\/checkouts\//.test(window.location.pathname);
  0 !== p &&
    !1 === i &&
    xe &&
    !qe &&
    (o("Blocker will execute"),
    (document.createElement = function (...t) {
      if ("script" !== t[0].toLowerCase())
        return P.bind ? P.bind(document)(...t) : P;
      const n = P.bind(document)(...t);
      try {
        Object.defineProperties(n, {
          src: {
            ...E.src,
            set(t) {
              L(t, n.type) && E.type.set.call(this, e), E.src.set.call(this, t);
            },
          },
          type: {
            ...E.type,
            get() {
              const t = E.type.get.call(this);
              return t === e || L(this.src, t) ? null : t;
            },
            set(t) {
              const a = L(n.src, n.type) ? e : t;
              E.type.set.call(this, a);
            },
          },
        }),
          (n.setAttribute = function (t, a) {
            if ("type" === t) {
              const t = L(n.src, n.type) ? e : a;
              E.type.set.call(n, t);
            } else
              "src" === t
                ? (L(a, n.type) && E.type.set.call(n, e), E.src.set.call(n, a))
                : HTMLScriptElement.prototype.setAttribute.call(n, t, a);
          });
      } catch (e) {
        console.warn(
          "Yett: unable to prevent script execution for script src ",
          n.src,
          ".\n",
          'A likely cause would be because you are using a third-party browser extension that monkey patches the "document.createElement" function.',
        );
      }
      return n;
    }),
    $.observe(document.documentElement, { childList: !0, subtree: !0 }),
    A.observe(document.documentElement, { childList: !0, subtree: !0 }));
})();
